import { useEffect, useState } from "react";
import api from "../lib/api";
import { Plus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

const COLUMNS = [
  { id: "prospect",    label: "🔍 Prospect",       color: "#3B82F6" },
  { id: "contacted",   label: "📩 Contacté",       color: "#F59E0B" },
  { id: "negotiating", label: "💬 En discussion",  color: "#7C3AED" },
  { id: "partner",     label: "🤝 Partenaire",     color: "#10B981" },
  { id: "archived",    label: "📦 Archivé",        color: "#9CA3AF" },
];

export default function CRMPipeline() {
  const [contacts, setContacts] = useState([]);
  const [dragged, setDragged] = useState(null);

  const refresh = async () => {
    try { setContacts(await api.crmListContacts()); } catch { toast.error("Erreur"); }
  };
  useEffect(() => { refresh(); }, []);

  const move = async (id, status) => {
    setContacts(cs => cs.map(c => c.id === id ? { ...c, status } : c));
    try { await api.crmUpdateContact(id, { status, last_interaction: new Date().toISOString() }); }
    catch { refresh(); toast.error("Erreur"); }
  };

  return (
    <div className="space-y-6 animate-fadeUp" data-testid="crm-pipeline-page">
      <header>
        <div className="text-[10px] font-semibold uppercase tracking-[0.14em]" style={{ color: "var(--brand-pink)" }}>CRM Social</div>
        <h1 className="font-display text-4xl font-bold tracking-tight" style={{ color: "var(--text-primary)" }}>Pipeline Kanban</h1>
        <p className="text-sm mt-1.5" style={{ color: "var(--text-muted)" }}>Drag & drop tes contacts entre les étapes de relation.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {COLUMNS.map(col => {
          const items = contacts.filter(c => c.status === col.id);
          return (
            <div key={col.id} data-testid={`pipeline-col-${col.id}`}
              onDragOver={e => e.preventDefault()}
              onDrop={() => { if (dragged) move(dragged, col.id); setDragged(null); }}
              className="surface p-3 min-h-[200px]">
              <div className="flex items-center gap-2 mb-3 pb-2" style={{ borderBottom: `2px solid ${col.color}` }}>
                <span className="text-sm font-semibold" style={{ color: "var(--text-primary)" }}>{col.label}</span>
                <span className="ml-auto text-xs font-mono px-1.5 py-0.5 rounded-md" style={{ background: col.color + "20", color: col.color }}>{items.length}</span>
              </div>
              <div className="space-y-2">
                {items.map((c, i) => (
                  <div key={c.id} draggable onDragStart={() => setDragged(c.id)}
                    data-testid={`pipeline-card-${col.id}-${i}`}
                    className="p-3 rounded-lg cursor-grab active:cursor-grabbing transition surface-hover"
                    style={{ background: "var(--bg-base)", border: "1px solid var(--border-default)" }}>
                    <div className="flex items-start gap-2.5 mb-2">
                      <div className="w-7 h-7 rounded-full cdo-gradient flex items-center justify-center text-white text-[10px] font-bold shrink-0">{c.name.slice(0, 2).toUpperCase()}</div>
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-semibold truncate" style={{ color: "var(--text-primary)" }}>{c.name}</div>
                        <div className="text-[10px] font-mono truncate" style={{ color: "var(--text-muted)" }}>@{c.handle} · {c.platform}</div>
                      </div>
                    </div>
                    <div className="flex items-center justify-between text-[10px]">
                      <span style={{ color: "var(--text-muted)" }}>{c.niche || "—"}</span>
                      {c.estimated_value > 0 && <span className="font-mono font-bold" style={{ color: col.color }}>{c.estimated_value}€</span>}
                    </div>
                  </div>
                ))}
                {items.length === 0 && <div className="text-[10px] text-center py-4" style={{ color: "var(--text-muted)" }}>Glisse-dépose ici</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
